// import { useState, useRef, useEffect, useMemo } from 'react'
// import style from './SupportBlock.module.css'
// import { useTranslation } from 'react-i18next'
// import { CustomerTel } from '../../../Assets/Images/ContactsPage'
// import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'
//
// const SupportBlock = ({ customerData }) => {
//   const { t } = useTranslation()
//   const fileInputRef = useRef(null)
//   const [equipmentData, setEquipmentData] = useState({})
//   const [isLoadingData, setIsLoadingData] = useState(true)
//
//   const breadcrumbItems = useMemo(
//     () => [
//       { path: '/', label: t('breadcrumbs.home') },
//       { path: '/engineering', label: t('breadcrumbs.engineering') },
//       {
//         path: '/engineering/customer-support',
//         label: t('breadcrumbs.support'),
//       },
//     ],
//     [t],
//   )
//
//   // Функція для парсингу API відповіді в потрібний формат
//   const parseApiData = (apiData) => {
//     const result = {}
//     apiData.forEach((manufacturer) => {
//       const manufacturerName = manufacturer.name
//       result[manufacturerName] = {}
//       if (manufacturer.sub && manufacturer.sub.items) {
//         manufacturer.sub.items.forEach((model) => {
//           const modelName = model.name
//           result[manufacturerName][modelName] = []
//           if (model.sub && model.sub.items) {
//             model.sub.items.forEach((serial) => {
//               result[manufacturerName][modelName].push(serial.name)
//             })
//             // Сортуємо серійні номери в алфавітному порядку
//             result[manufacturerName][modelName].sort()
//           }
//         })
//       }
//     })
//
//     // Сортуємо моделі для кожного виробника
//     Object.keys(result).forEach((manufacturer) => {
//       const sortedModels = {}
//       Object.keys(result[manufacturer])
//         .sort()
//         .forEach((model) => {
//           sortedModels[model] = result[manufacturer][model]
//         })
//       result[manufacturer] = sortedModels
//     })
//
//     return result
//   }
//
//   // Завантаження даних з API з використанням customer_id
//   useEffect(() => {
//     const fetchEquipmentData = async () => {
//       try {
//         setIsLoadingData(true)
//
//         // Використовуємо customer_id для отримання фільтрованих даних
//         const customerId = customerData?.customer_id
//         if (!customerId) {
//           throw new Error('Customer ID not found')
//         }
//
//         const response = await fetch(
//           `https://3dprostir.aima.in.ua/?ajax=import&action=3dprostir&type=menu&customer_id=${customerId}`,
//         )
//
//         if (!response.ok) {
//           throw new Error('Failed to fetch equipment data')
//         }
//
//         const apiData = await response.json()
//         const parsedData = parseApiData(apiData)
//         setEquipmentData(parsedData)
//       } catch (error) {
//         console.error('Error fetching equipment data:', error)
//         // Fallback до порожнього об'єкта в разі помилки
//         setEquipmentData({})
//       } finally {
//         setIsLoadingData(false)
//       }
//     }
//
//     if (customerData?.customer_id) {
//       fetchEquipmentData()
//     }
//   }, [customerData])
//
//   // Отримуємо відсортованих виробників
//   const sortedManufacturers = useMemo(() => {
//     return Object.keys(equipmentData).sort()
//   }, [equipmentData])
//
//   // Мапа для поштових адрес, оновлена для багатомовної підтримки
//   const serviceEmails = useMemo(
//     () => ({
//       [t('form.repair')]: '4afa1057.itton.onmicrosoft.com@emea.teams.ms',
//       [t('form.spareParts')]: '60cf30f2.itton.onmicrosoft.com@emea.teams.ms',
//       [t('form.consumables')]: '5a0ee32c.itton.onmicrosoft.com@emea.teams.ms',
//       // [t('form.repair')]: 'sasha236541@gmail.com',
//       // [t('form.spareParts')]: 'sasha236541@gmail.com',
//       // [t('form.consumables')]: 'sasha236541@gmail.com',
//     }),
//     [t],
//   )
//
//   const [formData, setFormData] = useState({
//     name: 'null',
//     phone: 'null',
//     email: '',
//     comment: '',
//     to: serviceEmails['Запчастини'],
//   })
//
//   const [formDetails, setFormDetails] = useState({
//     serviceType: 'Запчастини',
//     manufacturer: '',
//     model: '',
//     serialNumber: '',
//   })
//
//   const [notifications, setNotifications] = useState([])
//   const [fileName, setFileName] = useState('')
//   const [fileData, setFileData] = useState(null)
//
//   useEffect(() => {
//     // оновлення email на основі типу послуги
//     setFormData((prev) => ({
//       ...prev,
//       to: serviceEmails[formDetails.serviceType] || 'default@example.com',
//     }))
//   }, [formDetails.serviceType, serviceEmails])
//
//   const handleChange = (e) => {
//     const { name, value } = e.target
//     if (name === 'manufacturer') {
//       setFormDetails({
//         ...formDetails,
//         [name]: value,
//         model: '',
//         serialNumber: '',
//       })
//     } else if (name === 'model') {
//       setFormDetails({
//         ...formDetails,
//         [name]: value,
//         serialNumber: '',
//       })
//     } else if (name === 'serialNumber') {
//       setFormDetails({
//         ...formDetails,
//         [name]: value,
//       })
//     } else {
//       setFormData({
//         ...formData,
//         [name]: value,
//       })
//     }
//   }
//
//   const handleServiceTypeChange = (type) => {
//     setFormDetails({
//       ...formDetails,
//       serviceType: type,
//     })
//   }
//
//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setFileName(e.target.files[0].name)
//       setFileData(e.target.files[0])
//     }
//   }
//
//   const triggerFileInput = () => {
//     fileInputRef.current.click()
//   }
//
//   const showNotification = (message) => {
//     setNotifications((prev) => [...prev, message])
//     setTimeout(() => {
//       setNotifications((prev) => prev.filter((msg) => msg !== message))
//     }, 3000)
//   }
//
//   const validateForm = () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
//     if (!emailRegex.test(formData.email)) {
//       showNotification(t('form.alarmEmail') || 'Invalid email format')
//       return false
//     }
//     if (!formDetails.manufacturer) {
//       showNotification(
//         t('form.manufacturerRequired') || 'Manufacturer is required',
//       )
//       return false
//     }
//     if (!formDetails.model) {
//       showNotification(t('form.modelRequired') || 'Model is required')
//       return false
//     }
//     return true
//   }
//
//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     if (!validateForm()) return
//
//     const currentPageUrl = window.location.href
//     const enhancedComment = `${
//       formData.comment || ''
//     }\n\nСторінка: ${currentPageUrl}\nТип послуги: ${
//       formDetails.serviceType
//     }\nВиробник: ${formDetails.manufacturer}\nМодель: ${
//       formDetails.model
//     }\nСерійний номер: ${formDetails.serialNumber || '—'}${
//       fileName ? `\nФайл: ${fileName}` : ''
//     }\nКлієнт ID: ${customerData?.customer_id || 'N/A'}`
//
//     const emailSubject = `${formDetails.manufacturer}/${formDetails.model}/${
//       formDetails.serialNumber || 'N/A'
//     }/${formData.email}`
//
//     try {
//       const formDataToSend = new FormData()
//       formDataToSend.append('name', formData.name)
//       formDataToSend.append('phone', formData.phone)
//       formDataToSend.append('email', formData.email)
//       formDataToSend.append('comment', enhancedComment)
//       formDataToSend.append('to', formData.to)
//       formDataToSend.append('subject', emailSubject)
//
//       if (fileData) {
//         formDataToSend.append('file', fileData)
//       }
//
//       const response = await fetch(
//         'https://prostir3dmailer.balanceglobal.com.ua/post',
//         {
//           method: 'POST',
//           body: formDataToSend,
//         },
//       )
//
//       if (!response.ok) throw new Error('Network error')
//
//       const data = await response.json()
//       console.log(data)
//       showNotification(t('form.formSend') || 'Form sent successfully')
//       reset()
//     } catch (error) {
//       console.error('Form send error:', error)
//       showNotification(t('form.formdontSend') || 'Failed to send form')
//     }
//   }
//
//   const reset = () => {
//     setFormData({
//       name: '',
//       phone: '',
//       email: '',
//       comment: '',
//       to: serviceEmails['Запчастини'],
//     })
//     setFormDetails({
//       serviceType: 'Запчастини',
//       manufacturer: '',
//       model: '',
//       serialNumber: '',
//     })
//     setFileName('')
//     setFileData(null)
//     if (fileInputRef.current) {
//       fileInputRef.current.value = ''
//     }
//   }
//
//   // Показуємо індикатор завантаження, якщо дані ще завантажуються
//   if (isLoadingData) {
//     return (
//       <div className={style.contacts}>
//         <div className={`customContainer ${style.form_wrap}`}>
//           <div className={style.loading}>Завантаження даних обладнання...</div>
//         </div>
//       </div>
//     )
//   }
//
//   return (
//     <div className={style.contacts}>
//       <div className={`customContainer ${style.form_wrap}`}>
//         <Breadcrumbs items={breadcrumbItems} absolute={true} />
//         <h2 className={style.contacts_title}>{t('form.title2')}</h2>
//         <p className={style.contacts_desc}>{t('form.desc2')}</p>
//
//         {notifications.map((msg, index) => (
//           <div key={index} className={style.notification}>
//             {msg}
//           </div>
//         ))}
//
//         <form onSubmit={handleSubmit}>
//           <div className={style.radioGroup}>
//             {['repair', 'spareParts', 'consumables'].map((key) => {
//               const label = t(`form.${key}`)
//               return (
//                 <div
//                   key={key}
//                   className={`${style.radioOption} ${
//                     formDetails.serviceType === t(`form.${key}`)
//                       ? style.radioSelected
//                       : ''
//                   }`}
//                   onClick={() => handleServiceTypeChange(t(`form.${key}`))}
//                 >
//                   <div className={style.radioCircle}>
//                     {formDetails.serviceType === t(`form.${key}`) && (
//                       <div className={style.radioInner}></div>
//                     )}
//                   </div>
//                   <span>{label}</span>
//                 </div>
//               )
//             })}
//           </div>
//
//           <div className={style.inputGroup}>
//             <div className={style.selectWrapper}>
//               <select
//                 name="manufacturer"
//                 value={formDetails.manufacturer}
//                 onChange={handleChange}
//                 className={style.input}
//                 required
//               >
//                 <option value="" disabled>
//                   {t('form.manufacturer')}
//                 </option>
//                 {sortedManufacturers.map((manufacturer) => (
//                   <option key={manufacturer} value={manufacturer}>
//                     {manufacturer}
//                   </option>
//                 ))}
//               </select>
//               <div className={style.selectArrow}></div>
//             </div>
//           </div>
//
//           <select
//             name="model"
//             value={formDetails.model}
//             onChange={handleChange}
//             className={`${style.input} ${
//               !formDetails.manufacturer ? style.disabledSelect : ''
//             }`}
//             required
//             disabled={!formDetails.manufacturer}
//           >
//             <option value="" disabled>
//               {t('form.model')}
//             </option>
//             {formDetails.manufacturer &&
//               equipmentData[formDetails.manufacturer] &&
//               Object.keys(equipmentData[formDetails.manufacturer]).map(
//                 (model) => (
//                   <option key={model} value={model}>
//                     {model}
//                   </option>
//                 ),
//               )}
//           </select>
//
//           <select
//             name="serialNumber"
//             value={formDetails.serialNumber}
//             onChange={handleChange}
//             className={`${style.input} ${
//               !formDetails.model ? style.disabledSelect : ''
//             }`}
//             required
//             disabled={!formDetails.model}
//           >
//             <option value="" disabled>
//               {t('form.series')}
//             </option>
//             {formDetails.manufacturer &&
//               formDetails.model &&
//               equipmentData[formDetails.manufacturer] &&
//               equipmentData[formDetails.manufacturer][formDetails.model] &&
//               equipmentData[formDetails.manufacturer][formDetails.model].map(
//                 (serial) => (
//                   <option key={serial} value={serial}>
//                     {serial}
//                   </option>
//                 ),
//               )}
//           </select>
//
//           <div className={style.inputGroup}>
//             <input
//               id="comment"
//               name="comment"
//               value={formData.comment}
//               onChange={handleChange}
//               placeholder={t('form.comment2')}
//               className={style.input}
//               required
//             />
//           </div>
//
//           <div className={style.inputGroup}>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               placeholder={t('form.email')}
//               className={style.input}
//             />
//           </div>
//
//           <input
//             type="file"
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//           />
//
//           <div className={style.buttonGroup}>
//             <button className={style.button} type="submit">
//               {t('form.button')}
//             </button>
//             <button
//               className={style.attachButton}
//               type="button"
//               onClick={triggerFileInput}
//             >
//               {t('form.button2')}
//               {fileName && <span className={style.fileName}>{fileName}</span>}
//             </button>
//           </div>
//         </form>
//
//         <img
//           className={style.img_mobile}
//           src={CustomerTel || '/placeholder.svg'}
//           alt="CustomerTel"
//         />
//       </div>
//     </div>
//   )
// }
//
// export default SupportBlock

import { useState, useRef, useEffect, useMemo } from 'react'
import style from './SupportBlock.module.css'
import { useTranslation } from 'react-i18next'
import { CustomerTel } from '../../../Assets/Images/ContactsPage'
import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'

const SupportBlock = ({ customerData }) => {
  const { t } = useTranslation()
  const fileInputRef = useRef(null)

  const [equipmentData, setEquipmentData] = useState({})
  const [isLoadingData, setIsLoadingData] = useState(true)

  const breadcrumbItems = useMemo(
    () => [
      { path: '/', label: t('breadcrumbs.home') },
      { path: '/engineering', label: t('breadcrumbs.engineering') },
      {
        path: '/engineering/customer-support',
        label: t('breadcrumbs.support'),
      },
    ],
    [t],
  )

  // ============================================================================
  // Парсинг API відповіді в потрібний формат (ВАЖЛИВО: не губимо opts)
  // equipmentData = {
  //   "MANUFACTURER": {
  //     "MODEL": [
  //        { name: "SERIAL", opts: { date_start, date_end } },
  //        ...
  //     ]
  //   }
  // }
  // ============================================================================
  const parseApiData = (apiData) => {
    const result = {}

    apiData.forEach((manufacturer) => {
      const manufacturerName = manufacturer?.name
      if (!manufacturerName) return

      result[manufacturerName] = {}

      if (manufacturer.sub?.items) {
        manufacturer.sub.items.forEach((model) => {
          const modelName = model?.name
          if (!modelName) return

          result[manufacturerName][modelName] = []

          if (model.sub?.items) {
            model.sub.items.forEach((serial) => {
              const serialName = serial?.name
              if (!serialName) return

              result[manufacturerName][modelName].push({
                name: serialName,
                opts: serial?.opts || null,
              })
            })

            // Сортуємо серійні номери в алфавітному порядку
            result[manufacturerName][modelName].sort((a, b) =>
              String(a.name).localeCompare(String(b.name)),
            )
          }
        })
      }
    })

    // Сортуємо моделі для кожного виробника
    Object.keys(result).forEach((manufacturer) => {
      const sortedModels = {}
      Object.keys(result[manufacturer])
        .sort()
        .forEach((model) => {
          sortedModels[model] = result[manufacturer][model]
        })
      result[manufacturer] = sortedModels
    })

    return result
  }

  // ============================================================================
  // Завантаження даних з API з використанням customer_id
  // ============================================================================
  useEffect(() => {
    const fetchEquipmentData = async () => {
      try {
        setIsLoadingData(true)

        const customerId = customerData?.customer_id
        if (!customerId) {
          throw new Error('Customer ID not found')
        }

        const response = await fetch(
          `https://3dprostir.aima.in.ua/?ajax=import&action=3dprostir&type=menu&customer_id=${customerId}`,
        )

        if (!response.ok) {
          throw new Error('Failed to fetch equipment data')
        }

        const apiData = await response.json()
        const parsedData = parseApiData(apiData)
        setEquipmentData(parsedData)
      } catch (error) {
        console.error('Error fetching equipment data:', error)
        setEquipmentData({})
      } finally {
        setIsLoadingData(false)
      }
    }

    if (customerData?.customer_id) {
      fetchEquipmentData()
    }
  }, [customerData])

  // ============================================================================
  // Виробники (відсортовані)
  // ============================================================================
  const sortedManufacturers = useMemo(() => {
    return Object.keys(equipmentData).sort()
  }, [equipmentData])

  // ============================================================================
  // Мапа email по типу сервісу (multi-language через t())
  // ============================================================================
  const serviceEmails = useMemo(
    () => ({
      [t('form.repair')]: '4afa1057.itton.onmicrosoft.com@emea.teams.ms',
      [t('form.spareParts')]: '60cf30f2.itton.onmicrosoft.com@emea.teams.ms',
      [t('form.consumables')]: '5a0ee32c.itton.onmicrosoft.com@emea.teams.ms',

      // [t('form.repair')]: 'sasha236541@gmail.com',
      // [t('form.spareParts')]: 'sasha236541@gmail.com',
      // [t('form.consumables')]: 'sasha236541@gmail.com',
    }),
    [t],
  )

  const [formData, setFormData] = useState({
    name: 'null',
    phone: 'null',
    email: '',
    comment: '',
    to: serviceEmails['Запчастини'],
  })

  // ============================================================================
  // formDetails: додаємо приховані дати гарантії
  // ============================================================================
  const [formDetails, setFormDetails] = useState({
    serviceType: 'Запчастини',
    manufacturer: '',
    model: '',
    serialNumber: '',
    warrantyDateStart: '',
    warrantyDateEnd: '',
  })

  const [notifications, setNotifications] = useState([])
  const [fileName, setFileName] = useState('')
  const [fileData, setFileData] = useState(null)

  // ============================================================================
  // Оновлення email на основі типу послуги
  // ============================================================================
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      to: serviceEmails[formDetails.serviceType] || 'default@example.com',
    }))
  }, [formDetails.serviceType, serviceEmails])

  // ============================================================================
  // Обробка зміни полів форми
  // manufacturer -> reset model/serial + reset warranty dates
  // model -> reset serial + reset warranty dates
  // serialNumber -> знайти opts і зберегти warrantyDateStart/warrantyDateEnd
  // ============================================================================
  const handleChange = (e) => {
    const { name, value } = e.target

    if (name === 'manufacturer') {
      setFormDetails({
        ...formDetails,
        manufacturer: value,
        model: '',
        serialNumber: '',
        warrantyDateStart: '',
        warrantyDateEnd: '',
      })
      return
    }

    if (name === 'model') {
      setFormDetails({
        ...formDetails,
        model: value,
        serialNumber: '',
        warrantyDateStart: '',
        warrantyDateEnd: '',
      })
      return
    }

    if (name === 'serialNumber') {
      const serials =
        equipmentData?.[formDetails.manufacturer]?.[formDetails.model] || []
      const selectedSerialObj = serials.find((s) => s?.name === value)

      setFormDetails({
        ...formDetails,
        serialNumber: value,
        warrantyDateStart: selectedSerialObj?.opts?.date_start || '',
        warrantyDateEnd: selectedSerialObj?.opts?.date_end || '',
      })
      return
    }

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleServiceTypeChange = (type) => {
    setFormDetails({
      ...formDetails,
      serviceType: type,
    })
  }

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name)
      setFileData(e.target.files[0])
    }
  }

  const triggerFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.click()
  }

  const showNotification = (message) => {
    setNotifications((prev) => [...prev, message])
    setTimeout(() => {
      setNotifications((prev) => prev.filter((msg) => msg !== message))
    }, 3000)
  }

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.email)) {
      showNotification(t('form.alarmEmail') || 'Invalid email format')
      return false
    }
    if (!formDetails.manufacturer) {
      showNotification(
        t('form.manufacturerRequired') || 'Manufacturer is required',
      )
      return false
    }
    if (!formDetails.model) {
      showNotification(t('form.modelRequired') || 'Model is required')
      return false
    }
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return

    const currentPageUrl = window.location.href

    const enhancedComment = `${
      formData.comment || ''
    }\n\nСторінка: ${currentPageUrl}\nТип послуги: ${
      formDetails.serviceType
    }\nВиробник: ${formDetails.manufacturer}\nМодель: ${
      formDetails.model
    }\nСерійний номер: ${formDetails.serialNumber || '—'}\nДата акту: ${
      formDetails.warrantyDateStart || '—'
    }\nДата кінця гарантії: ${formDetails.warrantyDateEnd || '—'}${
      fileName ? `\nФайл: ${fileName}` : ''
    }\nКлієнт ID: ${customerData?.customer_id || 'N/A'}`

    const emailSubject = `${formDetails.manufacturer}/${formDetails.model}/${
      formDetails.serialNumber || 'N/A'
    }/${formData.email}`

    try {
      const formDataToSend = new FormData()
      formDataToSend.append('name', formData.name)
      formDataToSend.append('phone', formData.phone)
      formDataToSend.append('email', formData.email)
      formDataToSend.append('comment', enhancedComment)
      formDataToSend.append('to', formData.to)
      formDataToSend.append('subject', emailSubject)

      if (fileData) {
        formDataToSend.append('file', fileData)
      }

      const response = await fetch(
        'https://prostir3dmailer.balanceglobal.com.ua/post',
        {
          method: 'POST',
          body: formDataToSend,
        },
      )

      if (!response.ok) throw new Error('Network error')

      const data = await response.json()
      console.log(data)
      showNotification(t('form.formSend') || 'Form sent successfully')
      reset()
    } catch (error) {
      console.error('Form send error:', error)
      showNotification(t('form.formdontSend') || 'Failed to send form')
    }
  }

  const reset = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      comment: '',
      to: serviceEmails['Запчастини'],
    })
    setFormDetails({
      serviceType: 'Запчастини',
      manufacturer: '',
      model: '',
      serialNumber: '',
      warrantyDateStart: '',
      warrantyDateEnd: '',
    })
    setFileName('')
    setFileData(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  // ============================================================================
  // Loading state
  // ============================================================================
  if (isLoadingData) {
    return (
      <div className={style.contacts}>
        <div className={`customContainer ${style.form_wrap}`}>
          <div className={style.loading}>Завантаження даних обладнання...</div>
        </div>
      </div>
    )
  }

  return (
    <div className={style.contacts}>
      <div className={`customContainer ${style.form_wrap}`}>
        <Breadcrumbs items={breadcrumbItems} absolute={true} />
        <h2 className={style.contacts_title}>{t('form.title2')}</h2>
        <p className={style.contacts_desc}>{t('form.desc2')}</p>

        {notifications.map((msg, index) => (
          <div key={index} className={style.notification}>
            {msg}
          </div>
        ))}

        <form onSubmit={handleSubmit}>
          <div className={style.radioGroup}>
            {['repair', 'spareParts', 'consumables'].map((key) => {
              const label = t(`form.${key}`)
              return (
                <div
                  key={key}
                  className={`${style.radioOption} ${
                    formDetails.serviceType === t(`form.${key}`)
                      ? style.radioSelected
                      : ''
                  }`}
                  onClick={() => handleServiceTypeChange(t(`form.${key}`))}
                >
                  <div className={style.radioCircle}>
                    {formDetails.serviceType === t(`form.${key}`) && (
                      <div className={style.radioInner}></div>
                    )}
                  </div>
                  <span>{label}</span>
                </div>
              )
            })}
          </div>

          <div className={style.inputGroup}>
            <div className={style.selectWrapper}>
              <select
                name="manufacturer"
                value={formDetails.manufacturer}
                onChange={handleChange}
                className={style.input}
                required
              >
                <option value="" disabled>
                  {t('form.manufacturer')}
                </option>
                {sortedManufacturers.map((manufacturer) => (
                  <option key={manufacturer} value={manufacturer}>
                    {manufacturer}
                  </option>
                ))}
              </select>
              <div className={style.selectArrow}></div>
            </div>
          </div>

          <select
            name="model"
            value={formDetails.model}
            onChange={handleChange}
            className={`${style.input} ${
              !formDetails.manufacturer ? style.disabledSelect : ''
            }`}
            required
            disabled={!formDetails.manufacturer}
          >
            <option value="" disabled>
              {t('form.model')}
            </option>
            {formDetails.manufacturer &&
              equipmentData[formDetails.manufacturer] &&
              Object.keys(equipmentData[formDetails.manufacturer]).map(
                (model) => (
                  <option key={model} value={model}>
                    {model}
                  </option>
                ),
              )}
          </select>

          <select
            name="serialNumber"
            value={formDetails.serialNumber}
            onChange={handleChange}
            className={`${style.input} ${
              !formDetails.model ? style.disabledSelect : ''
            }`}
            required
            disabled={!formDetails.model}
          >
            <option value="" disabled>
              {t('form.series')}
            </option>

            {formDetails.manufacturer &&
              formDetails.model &&
              equipmentData[formDetails.manufacturer] &&
              equipmentData[formDetails.manufacturer][formDetails.model] &&
              equipmentData[formDetails.manufacturer][formDetails.model].map(
                (serial) => (
                  <option key={serial.name} value={serial.name}>
                    {serial.name}
                  </option>
                ),
              )}
          </select>

          <div className={style.inputGroup}>
            <input
              id="comment"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              placeholder={t('form.comment2')}
              className={style.input}
              required
            />
          </div>

          <div className={style.inputGroup}>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder={t('form.email')}
              className={style.input}
            />
          </div>

          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />

          <div className={style.buttonGroup}>
            <button className={style.button} type="submit">
              {t('form.button')}
            </button>
            <button
              className={style.attachButton}
              type="button"
              onClick={triggerFileInput}
            >
              {t('form.button2')}
              {fileName && <span className={style.fileName}>{fileName}</span>}
            </button>
          </div>
        </form>

        <img
          className={style.img_mobile}
          src={CustomerTel || '/placeholder.svg'}
          alt="CustomerTel"
        />
      </div>
    </div>
  )
}

export default SupportBlock
